/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */
import usePageMeta from "utils/usePageMeta";
import MKBox from "components/MKBox";

// Layout
import SubPageLayout from "reusables/layouts/SubPageLayout";

// Sections
import TnC_Section1 from "./sections/TnC_Section1";

function TnC() {
  usePageMeta({
    title: "Terms & Conditions | Spechs Ireland",
    description:
      "Read the Spechs terms and conditions for our cleaning, property management, and workforce services.",
    canonical: "https://www.spechs.ie/tnc/",
  });
  return (
    <SubPageLayout title="Terms & Conditions">
      <MKBox component="section" py={{ xs: 3, md: 12 }}>
        <TnC_Section1 />
      </MKBox>
    </SubPageLayout>
  );
}

export default TnC;
